<div class="gh-siv-section okr-task-section" data-test-id="okr-tasks-section">
  <div class="gh-siv-top-bar">
    <div class="gh-siv-title section-title">
      <i class="fs-16px sp-mr-10" ui-icon uiTheme="fill" uiType="task"></i>
      <h3>{{ "tasks" | localize }}</h3>

      <div
        class="sp-ml-12 sp-mr-12"
        *ngIf="piContextualSuggestionsEnabled && isSuggestingTasksToOKRsEnabled && (hasManageTasksPermission$ | async) && taskList.length < 3 && (!isTasksSuggestionVisible || isAtLeastOneTaskHidden)">
        <pi-contextual-suggestion-button (toggle)="setTasksSuggestionVisibility()" data-test-id="pi-tasks-contextual-suggestion-button"></pi-contextual-suggestion-button>
      </div>

      <div class="gh-siv-section-action">
        <div class="add-section-item">
          <button *ngIf="hasManageTasksPermission$ | async" [attr.aria-describedby]="'okr_tasks_aria_description'" (click)="goToCreateTaskModal()" ui-button uiType="link" uiShape="round">
            <i ui-icon uiType="plus"></i>
            <span>{{ "add_a_task" | localize }}</span>
            <span class="a11y-description" id="okr_tasks_aria_description">{{ "this_links_leads_to_currently_inaccessible_content" | localize }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <gh-indicator [(ghValue)]="indicators.loading" [ghMessage]="'getting_tasks' | localize"></gh-indicator>

  <div class="okr-row-wrapper" *ngIf="!indicators.loading">
    <div class="gh-siv-section-item" *ngFor="let task of taskList; trackBy: trackById" [id]="task.id" data-test-id="task-row">
      <okr-task-row [task]="task" [item]="item"></okr-task-row>
    </div>

    <div class="sp-mt-12">
      <quantive-plus-tasks
        *ngIf="isTasksSuggestionVisible && isSuggestingTasksToOKRsEnabled && (hasManageTasksPermission$ | async) && taskList.length < 3"
        [piContextualSuggestionsEnabled]="piContextualSuggestionsEnabled"
        [isRemoveBtnAvailable]="isRemoveBtnAvailable"
        [tasksInstance]="tasksInstance"
        [suggestionsStatus]="suggestionsStatus"
        [taskList]="taskList"
        [tasks]="suggestions?.tasks"
        [item]="item"
        [parentType]="parentType"
        [sessionId]="suggestions?.sessionId"
        [isInline]="hasInlineSuggestions"
        (taskCreate)="onQuantivePlusTaskCreated($event)"
        borderStyle="dashed">
      </quantive-plus-tasks>
    </div>
  </div>
</div>
